 document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.image-accordion-content__title').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('.image-accordion-content__item');
        item.classList.toggle('active');
      });
    });
  });

  